import React, {ReactNode, useMemo} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {AuthContext, AuthContextData} from '~/auth/AuthContext';

export const Auth0UserProvider: React.FC<{children: ReactNode}> = ({
  children
}) => {
  const auth0 = useAuth0();
  const isInternal: boolean = auth0.user?.internal ?? false;

  const auth0Context = useMemo<AuthContextData>(() => {
    return {
      user: auth0.user
        ? {
            id: auth0.user.sub ?? '',
            email: auth0.user.email ?? '',
            isInternal: isInternal ?? false,
            fullName: auth0.user.name ?? ''
          }
        : undefined,
      identityProvider: 'auth0',
      loginWithPopup: async () => auth0.loginWithPopup(),
      loginWithRedirect: async () => {
        await auth0.loginWithRedirect();
      },
      loginSilently: async () => {
        await auth0.getAccessTokenSilently({detailedResponse: true});
      },
      getTokens: async () => {
        const {id_token: idToken, access_token: accessToken} =
          await auth0.getAccessTokenSilently({
            detailedResponse: true
          });
        return {idToken, accessToken};
      },
      logout: async () => auth0.logout(),
      isLoading: auth0.isLoading
    };
  }, [auth0]);

  return (
    <AuthContext.Provider value={auth0Context}>{children}</AuthContext.Provider>
  );
};
